import React, { useState } from "react";
import "./Register.css";
import { insertUser } from '../api/riotApi';
import { useNavigate } from "react-router-dom";

const Register = () => {
  const navigate = useNavigate();
  const [form, setForm] = useState({
    name: "",
    userid: "",
    birth: "",
    phone: "",
    email: "",
    password: "",
    confirmPassword: "",
    gender: "",
  });

  const [errors, setErrors] = useState({});

  const validate = () => {
    const newErrors = {};

    // 이름: 필수, 최대 20자
    if (!form.name.trim()) {
      newErrors.name = "이름을 입력해주세요.";
    } else if (form.name.length > 20) {
      newErrors.name = "이름은 20자 이하로 입력해주세요.";
    }

    // 아이디: 필수, 5~20자, 영문+숫자만
    const idRegex = /^[a-zA-Z0-9]{5,20}$/;
    if (!form.userid.trim()) {
      newErrors.userid = "아이디를 입력해주세요.";
    } else if (!idRegex.test(form.userid)) {
      newErrors.userid = "아이디는 5~20자의 영문 또는 숫자만 가능합니다.";
    }

    // 비밀번호: 10~40자, 영문+숫자+특수문자
    const pwRegex = /^(?=.*[a-zA-Z])(?=.*\d)(?=.*[!@#$%^&*]).{10,40}$/;
    if (!form.password) {
      newErrors.password = "비밀번호를 입력해주세요.";
    } else if (!pwRegex.test(form.password)) {
      newErrors.password =
        "비밀번호는 10~40자이며 영문, 숫자, 특수문자를 포함해야 합니다.";
    }

    // 비밀번호 확인
    if (form.password !== form.confirmPassword) {
      newErrors.confirmPassword = "비밀번호가 일치하지 않습니다.";
    }

    // 생년월일: 필수, 미래 금지
    if (!form.birth) {
      newErrors.birth = "생년월일을 입력해주세요.";
    } else {
      const today = new Date().toISOString().split("T")[0];
      if (form.birth > today) {
        newErrors.birth = "생년월일은 미래로 설정할 수 없습니다.";
      }
    }

    // 전화번호: 필수
    if (!form.phone.trim()) {
      newErrors.phone = "전화번호를 입력해주세요.";
    }

    // 이메일: 정규식 검사
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!form.email.trim()) {
      newErrors.email = "이메일을 입력해주세요.";
    } else if (!emailRegex.test(form.email)) {
      newErrors.email = "이메일 형식이 올바르지 않습니다.";
    }

    // 성별: 필수
    if (!form.gender) {
      newErrors.gender = "성별을 선택해주세요.";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = (e) => {
      e.preventDefault();
      if (!validate()) return;

      const createdDate = new Date().toISOString(); // Timestamp 포맷

      const userData = {
        loginId: form.userid,
        passWd: form.password,
        email: form.email,
        phoneNo: form.phone,
        birthDate: form.birth, // yyyy-MM-dd 포맷이면 LocalDate로 자동 매핑됨
        sex: form.gender, // M or F
        userName: form.name,
        createdDate, // ISO 포맷으로 전송 → Timestamp로 매핑됨
      };

    insertUser(userData)
      .then(() => {
        alert("회원가입이 완료되었습니다!");
        navigate("/login"); // 로그인 페이지로 이동 (react-router-dom 사용 시)
      })
      .catch((err) => {
        if (err.response && err.response.status === 400) {
          const errorList = err.response.data;

          const errorObj = {};
          errorList.forEach((item) => {
            const fieldMap = {
              loginId: "userid",
              passWd: "password",
              email: "email",
              phoneNo: "phone",
              birthDate: "birth",
              sex: "gender",
              userName: "name",
            };
            const field = fieldMap[item.field];
            if (field) errorObj[field] = item.defaultMessage;
          });

          setErrors(errorObj);
        } else {
          alert("회원가입에 실패했습니다.");
        }
      });
  };

  return (
    <div className="register-container">
      <h2>회원가입</h2>
      <form onSubmit={handleSubmit}>
        <div>
        <p>이름</p>
        <input
          type="text"
          name="name"
          placeholder="홍길동"
          value={form.name}
          onChange={handleChange}
        />
        </div>
        {errors.name && <p className="error-text">{errors.name}</p>}

        <div>
        <p>아이디</p>
        <input
          type="text"
          name="userid"
          placeholder="abc123"
          value={form.userid}
          onChange={handleChange}
        />
        </div>
        {errors.userid && <p className="error-text">{errors.userid}</p>}

        <div>
        <p>비밀번호</p>
        <input
          type="password"
          name="password"
          placeholder="영문+숫자+특수문자, 10자 이상"
          value={form.password}
          onChange={handleChange}
        />
        </div>
        {errors.password && <p className="error-text">{errors.password}</p>}

        <div>
        <p>비밀번호 확인</p>
        <input
          type="password"
          name="confirmPassword"
          placeholder="영문+숫자+특수문자, 10자 이상"
          value={form.confirmPassword}
          onChange={handleChange}
        />
        </div>
        {errors.confirmPassword && (
          <p className="error-text">{errors.confirmPassword}</p>
        )}

        <div>
        <p>생년월일</p>
        <input
          type="date"
          name="birth"
          value={form.birth}
          onChange={handleChange}
        />
        </div>
        {errors.birth && <p className="error-text">{errors.birth}</p>}

        <div>
        <p>전화번호</p>
        <input
          type="tel"
          name="phone"
          placeholder="01054209802"
          value={form.phone}
          onChange={handleChange}
        />
        </div>
        {errors.phone && <p className="error-text">{errors.phone}</p>}

        <div>
        <p>이메일</p>
        <input
          type="email"
          name="email"
          placeholder="abc123@ctrl4.com"
          value={form.email}
          onChange={handleChange}
        />
        </div>
        {errors.email && <p className="error-text">{errors.email}</p>}

        <div className="gender-group">
        <p>성별</p>
          <label>
            <input
              type="radio"
              name="gender"
              value="M"
              checked={form.gender === "M"}
              onChange={handleChange}
            />
            남성
          </label>
          <label>
            <input
              type="radio"
              name="gender"
              value="F"
              checked={form.gender === "F"}
              onChange={handleChange}
            />
            여성
          </label>
        </div>
        {errors.gender && <p className="error-text">{errors.gender}</p>}

        <button type="submit">회원가입</button>
      </form>
    </div>
  );
};

export default Register;
